<h2 mat-dialog-title>Session Expiring</h2>
<mat-dialog-content>
  <p>Your session will end due to inactivity.</p>
  <p>You will be logged out in <strong>{{ secondsRemaining }}</strong> seconds.</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="onLogout()">Log out</button>
  <button mat-flat-button color="primary" (click)="onStayLoggedIn()">Stay logged in</button>
</mat-dialog-actions>
